const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

export const toFaDigits = (value: string | number): string =>
    String(value).replace(/[0-9]/g, digit => FA_DIGITS[Number(digit)])

export const toEnDigits = (value: string): string =>
    value
        .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06f0))
        .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660))

export const normalizePersian = (value: string): string =>
    value
        .replace(/ي/g, 'ی')
        .replace(/ى/g, 'ی')
        .replace(/ك/g, 'ک')
        .replace(/‏|‎/g, '')

export const formatNumber = (value: number): string => {
    const rounded = Math.round(Number.isFinite(value) ? value : 0)
    const sign = rounded < 0 ? '-' : ''
    const grouped = Math.abs(rounded).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '٬')

    return toFaDigits(`${sign}${grouped}`)
}

export const formatToman = (value: number): string => `${formatNumber(value)} تومان`

export const discountPercent = (price: number, compareAt: number | null | undefined): number => {
    if (!compareAt || compareAt <= price || compareAt <= 0) return 0

    return Math.round(((compareAt - price) / compareAt) * 100)
}

const TIME_ZONE = 'Asia/Tehran'

const dateFormatter = new Intl.DateTimeFormat('fa-IR', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: 'long',
    day: 'numeric'
})

const dateTimeFormatter = new Intl.DateTimeFormat('fa-IR', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
})

const dayMonthFormatter = new Intl.DateTimeFormat('fa-IR', {
    timeZone: TIME_ZONE,
    month: 'short',
    day: 'numeric'
})

const yearFormatter = new Intl.DateTimeFormat('fa-IR', {
    timeZone: TIME_ZONE,
    year: 'numeric'
})

const toDate = (value: string | Date | null | undefined): Date | null => {
    if (!value) return null

    const date = value instanceof Date ? value : new Date(value)

    return Number.isNaN(date.getTime()) ? null : date
}

export const formatDate = (value: string | Date | null | undefined, withTime = false): string => {
    const date = toDate(value)

    if (!date) return '-'

    return (withTime ? dateTimeFormatter : dateFormatter).format(date)
}

export const formatDayMonth = (value: string | Date | null | undefined): string => {
    const date = toDate(value)

    return date ? dayMonthFormatter.format(date) : '-'
}

export const formatYear = (value: string | Date): string => {
    const date = toDate(value)

    return date ? yearFormatter.format(date) : ''
}

export const isValidMobile = (value: string): boolean => /^09\d{9}$/.test(value)

export const normalizeMobile = (value: string): string => {
    const digits = toEnDigits(value).replace(/[\s-]/g, '')

    if (digits.startsWith('+98')) return `0${digits.slice(3)}`
    if (digits.startsWith('0098')) return `0${digits.slice(4)}`
    if (digits.startsWith('98') && digits.length === 12) return `0${digits.slice(2)}`

    return digits
}

export const formatCardNumber = (value: string): string =>
    toEnDigits(value).replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1-')
